import { render, staticRenderFns } from "./CreateSkill.vue?vue&type=template&id=8b25c6ba"
import script from "./CreateSkill.vue?vue&type=script&lang=js"
export * from "./CreateSkill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports